/**
 * Created by sagardesai on 11/06/18.
 */
import React, {Component} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import * as _ from 'lodash'
import {connect} from "react-redux";
import {Field, reduxForm} from 'redux-form';
import * as actions from "../actions";
import CryptoJS from "crypto-js";
import {withRouter} from 'react-router';
//internal imports
import channelImageBg from '../assets/images/channelImageBg.jpg';
import {getData, LOGIN} from "../util/storage";
import strings from "../util/strings";
import {isEmpty, isValidPassword, logout, required, vuepayAlert} from "../util/utility";
import {getUserDetailsFromAPI, passwordObject, renderField, renderTextAreaField} from "../util/account_management";

import {
    checkIfPrefinedTags,
    getChannelDescription,
    getChannelPicture,
    getTagsForAPI,
    getUserProfilePicture,
    tagsObject
} from "../util/broadcaster/profile_util";
import PlaceHolderComponent from "../components/PlaceHolderComponent";
//images
import loading_white from '../assets/gif/loading_white.gif';
import account_icon from '../assets/images/Account-icon.svg';
import ChannelPictureModal from "../components/modal/ChannelPictureModal";
import {faPen} from "@fortawesome/free-solid-svg-icons/index";

class UserProfile extends Component {

    required = value => (value ? undefined : 'Required');

    constructor(props) {
        super(props);
        this.state = {
            userDetails: {},
            isChangePasswordEnabled: false,
            isChangeEmailEnabled: false,
            image: null,
            count: 0,
            tags: [],
            type: 'password',
            class_name: 'btn btn-pwd-hide',
            current_pwd_type: 'password',
            new_password_pwd_type: 'password',
            confirm_password_pwd_type: 'password',
            current_pwd_class_name: 'btn btn-pwd-hide',
            new_password_class_name: 'btn btn-pwd-hide',
            confirm_password_class_name: 'btn btn-pwd-hide',
            predefinedTagsList: null,
            uploadType: "user_profile_pic"//broadcaster_profile_pic,user_profile_pic
        };
        this.showHidePassword = this.showHidePassword.bind(this);
        this.editChangePassword = this.editChangePassword.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.textAreaChange = this.textAreaChange.bind(this);
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        this.setState({
            userDetails: nextProps.account_management.userDetails
        });
        // this.state.userDetails = nextProps.account_management.userDetails

        if (window.location.pathname.indexOf("broadcaster") >= 0 &&
            nextProps.account_management.userDetails.broadcaster &&
            nextProps.account_management.userDetails.broadcaster !== null &&
            nextProps.account_management.userDetails.broadcaster.length > 0) {
            this.setState({
                isBroadcaster: true,
                count: getChannelDescription(this.props, 0),
            })

        }
        else {
            this.setState({
                isBroadcaster: false
            })
        }

        //if the status_code received from the server is 200 means the user has successfully changed password
        if (nextProps.account_management.changePassword) {
            if (nextProps.account_management.changePassword.status_code === 200) {
                vuepayAlert("success", nextProps.account_management.changePassword.message);
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                vuepayAlert("error", nextProps.account_management.changePassword.message);
            }
        }
        else if (nextProps.account_management.changeEmail) {
            if (nextProps.account_management.changeEmail.status_code === 200) {
                vuepayAlert("success", nextProps.account_management.changePassword.message, logout);
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                vuepayAlert("error", nextProps.account_management.changeEmail.message);
            }
        }

        if (window.location.pathname.indexOf("/broadcaster/create/profile") < 0) {

            if (nextProps.broadcasterProfile &&
                nextProps.broadcasterProfile.hasOwnProperty("payload") &&
                nextProps.broadcasterProfile.payload !== null) {
                if (nextProps.broadcasterProfile.payload.hasOwnProperty("status_code")) {
                    const message = nextProps.broadcasterProfile.payload.message;
                    nextProps.resetUploadChannelPicture();
                    if (nextProps.broadcasterProfile.payload.status_code === 200) {
                        vuepayAlert("success", message, () => {
                            getUserDetailsFromAPI(this.props)
                        })
                    } else {
                        vuepayAlert("error", message)
                    }
                }
            }
        }

        if (nextProps.predefinedTags &&
            nextProps.predefinedTags.payload !== null && this.state.isChannelTagsEdited) {
            this.setState({
                predefinedTagsList: nextProps.predefinedTags.payload
            })

            setTimeout(() => {
                this.prePopulateTags();
                this.props.resetPreDefinedTags()
            }, 500);

        }
    }

    // When user clicks on Edit button of Password field
    editChangePassword = () => {
        this.setState({
            isChangePasswordEnabled: true,
            isChangeEmailEnabled: false,
            image: null
        });
    };

    // When user clicks on Edit button of Email field
    editChangeEmail = () => {
        this.setState({
            isChangeEmailEnabled: true,
            isChangePasswordEnabled: false,
            image: null
        });
    };

    editChannelDescription = () => {
        this.setState({
            isChangeEmailEnabled: false,
            isChangePasswordEnabled: false,
            isChannelDescriptionEdited: true,
            image: null
        });
    };

    editChannelTag = () => {
        this.setState({
            isChangeEmailEnabled: false,
            isChangePasswordEnabled: false,
            isChannelDescriptionEdited: false,
            isChannelTagsEdited: true,
            image: null
        });

        this.setState({
            tags: []
        });
        //dispatch an action to get get all predefined tags from the Webservice
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.getPreDefinedTags(data.token, data.api_token);
                }
            })
    };


    onSubmit(values) {

        if (this.state.isChangePasswordEnabled) {
            const jsonData = {
                current_password: CryptoJS.MD5(values.current_password).toString(),
                new_password: CryptoJS.MD5(values.new_password).toString(),
                device: this.props.device
            };

            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        this.props.changePassword(jsonData, data.token, data.api_token);
                    }
                });
        }
        else {
            const jsonData = {
                current_email: values.email,
                new_email: values.new_email,
                device: this.props.device
            };

            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        this.props.changeEmail(jsonData, data.token, data.api_token);
                    }
                });
        }

    }

    hideUserProfile = () => {
        this.setState({
            isChangePasswordEnabled: false,
            isChangeEmailEnabled: false,
            isChannelDescriptionEdited: false,
            isChannelTagsEdited: false,
            current_pwd_class_name: 'btn btn-pwd-hide',
            new_password_class_name: 'btn btn-pwd-hide',
            confirm_password_class_name: 'btn btn-pwd-hide',
            current_pwd_type: 'password',
            new_password_pwd_type: 'password',
            confirm_password_pwd_type: 'password',
            image: null,
            tags: []

        });

        this.props.reset();
        this.props.resetPreDefinedTags()
        let modal = document.getElementById("user-profile-modal");
        modal.classList.remove("show")
        modal.style.display = "none"
        document.getElementsByClassName("modal-overlay")[0].style.display = "none"
    };

    //this function helps to toggle the state of password
    showHidePassword = (e) => {
        const targetName = e.target.name;
        const type = passwordObject[targetName].type;
        const class_name = passwordObject[targetName].class_name;
        const newObject = {};
        newObject[type] = this.state[type] === 'input' ? 'password' : 'input'
        newObject[class_name] = this.state[type] === 'input' ? 'btn btn-pwd-hide' : 'btn btn-pwd-show'
        this.setState(newObject);
    };

    // Check match for New password and confirm password
    checkPasswordsMatch = (value) => value &&
    document.getElementsByName("new_password")[0].value === value ? undefined : 'Passwords does not match';


    getSaveButtonName = () => {
        return this.state.isChangePasswordEnabled
            ? "Save password" : (this.state.isChangeEmailEnabled
                ? "Save email" : (this.state.isChannelDescriptionEdited
                    ? "Save channel description" : (this.state.isChannelTagsEdited)
                        ? "Save tags" : (this.state.isBroadcaster
                            ? "Save channel image" : "Save profile image")));
    };


    // This function is invoked when user taps on save Channel description
    onClickSaveChannelDescription = () => {

        if (document.getElementsByName("channel_description")[0].value.length < 20) {
            vuepayAlert("error", "Channel description should be minimum of 20 characters long")
        }
        else {
            const jsonData = {
                email: this.state.userDetails.email,
                tags: getTagsForAPI(this.state.userDetails.broadcaster[0].tags),
                description: document.getElementsByName("channel_description")[0].value,
                device: this.props.device
            };
            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        this.props.updateBroadcasterProfile(data.token, data.api_token, jsonData)
                    }
                })
        }

    };

    // This function is invoked when user taps on save Channel tags

    onClickSaveChannelTags = () => {

        if (this.state.tags.length === 0) {
            vuepayAlert("error", "Please select a minimum of one tag")
        }
        else {
            const jsonData = {
                email: this.state.userDetails.email,
                tags: getTagsForAPI(this.state.tags),
                description: this.state.userDetails.broadcaster[0].channel_description,
                device: this.props.device
            };

            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        this.props.updateBroadcasterProfile(data.token, data.api_token, jsonData)
                    }
                })
        }

    };

    /**
     * @function listener for text area change we use this to maintain the count of the characters the user has typed
     * @param e
     */
    textAreaChange(e) {
        this.setState({
            count: e.target.value.length,
        });
    }

    /**
     * @function formats the list of tags in semi colon separated string from array of objects
     */
    getListOfTags = () => {
        return this.state.userDetails.broadcaster[0].tags.map(function (elem) {
            return elem.name;
        }).join("; ");
    };

    /**
     * @function pre-populates the selected tags
     */
    prePopulateTags = () => {

        this.state.userDetails.broadcaster[0].tags.map((elem) => {
            if (elem.is_predefined === 1) {

                let element = document.getElementById(`predefined-${elem.id}`);
                if (element !== null && this.addElementIntoArray(tagsObject(elem.id, "true", elem.name))) {
                    element.classList.toggle("active")
                }
            }
            else {
                this.addElementIntoArray(tagsObject(elem.id, "false", elem.name));
            }
        });

    };

    /**
     * @function click listener for predefined tags which is use to toggle the state of the tags
     * @param e
     */
    togglePrefinedTags = (e) => {
        e.preventDefault();


        const element = document.getElementById(e.target.id);
        const name = e.target.dataset.name;
        const id = e.target.dataset.id;
        if (!element.classList.contains("active") && this.addElementIntoArray(tagsObject(id, "true", name))) {
            element.classList.toggle("active")
        } else {
            //remove the element
            const find = tagsObject(id, "true", name);
            this.removeElementFromArray(find)
        }
    }

    /**
     * @function click listener for adding custom tags
     * @param e
     */
    addTag = (e) => {
        e.preventDefault();

        const value = document.getElementById("create-new-tag").value;
        /**
         * Business rule
         * minimum length 2
         */
        if (value.length > 2) {
            this.addElementIntoArray(tagsObject(null, "false", value));
        } else {
            vuepayAlert("error", "Tag length should be more than two.")
        }
    }

    /**
     * @function which mutates the state of tags by adding more content
     * @param object
     * @returns {boolean}
     */
    addElementIntoArray = (object) => {
        let tags = this.state.tags;
        if (tags.length === 5) {
            vuepayAlert("error", "Maximum of five tags are allowed")
            return false;
        } else {
            //add new object into array

            const tagObj = this.state.tags.find(o => o.name.toLowerCase() === object.name.toLowerCase());
            if (tagObj == null || tagObj == undefined) {
                tags.push(object);
                this.setState({
                    tags: tags
                }, () => {
                    document.getElementById("create-new-tag").value = "";
                })
                return true;
            }
            else {
                vuepayAlert("error", "Tag already exists")
                return false;
            }


        }
    }

    /**
     * @function which mutates the state of tags by removing content
     * @param find
     */
    removeElementFromArray = (find) => {
        /*
         * 1. This will return the *index of the first* element that matches:
         */
        const index = _.findIndex(this.state.tags, (o) => {
            return _.isMatch(o, find)
        });

        //add the element
        let tags = this.state.tags;

        //Remove 1 element from index 3
        tags.splice(index, 1);

        this.setState({
            tags: tags
        }, () => {
            const element = document.getElementById("predefined-" + find.id);
            if (element) {
                element.classList.remove("active")
            }
        })
    };

    /**
     * @function click listener for deleting tags from my tags
     * @param e
     */
    removeTag = (e) => {
        e.preventDefault();
        const id = e.target.dataset.id;
        const ispredefined = e.target.dataset.ispredefined;
        const name = e.target.dataset.name;
        const find = tagsObject(id, ispredefined, name);

        this.removeElementFromArray(find)
    };


    render() {

        const {handleSubmit, reset} = this.props;
        const ready = checkIfPrefinedTags(this.props);

        return (
            <div id="user-profile-modal" className="modal fade" role="dialog" aria-labelledby="myModalLabel"
                 aria-hidden="true">

                <ChannelPictureModal
                    id={"user-profile-image-modal"}
                    type={this.state.uploadType}
                    setUserDetails={(userDetails) => {
                        this.setState({
                            userDetails
                        })
                    }}/>

                <div className="vertical-alignment-helper">
                    <div className="modal-dialog vertical-align-center">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                        onClick={this.hideUserProfile}><img alt={"close-icon"} src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"}/></button>
                            </div>
                            {
                                this.state.userDetails &&
                                <div className="modal-body">

                                    {
                                        this.state.isBroadcaster
                                            ?
                                            <div>
                                                <div className="top-card-channel-image relative"
                                                     style={{marginTop: -32}}>
                                                    <div tabIndex="0" id="ember2683"
                                                         className="channel-image--no-rounded-corners channel-image ember-view">
                                                        <div className="channel-image__image-container">
                                                            <img
                                                                className="channel-image__image relative full-width"
                                                                id="channel-image-target-image" alt="Background Image"
                                                                src={getChannelPicture(this.state.userDetails, channelImageBg, "channel_image_rectangle")}/>
                                                        </div>
                                                    </div>

                                                    <div className="channel-image-edit-button ember-view">
                                                        <button data-control-name="edit-channel-image"
                                                                className="channel-image-edit-button__edit-icon icon-button icon-button--circle icon-button--inverse icon-button--1 icon-button--primary ember-view"
                                                                type="button"
                                                                onClick={() => {
                                                                    //"broadcaster_channel_image"//broadcaster_profile_pic,user_profile_pic
                                                                    this.setState({
                                                                        uploadType: "broadcaster_channel_image"
                                                                    }, () => {
                                                                        document.getElementById("user-profile-image-modal-file").click()
                                                                    });
                                                                }}>
                                                            <FontAwesomeIcon icon={faPen} size="xs"/>
                                                            <span
                                                                className="icon-button__text">Upload Background Photo</span>
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="followers-img-wrapper">
                                                    <div className="followers-img">
                                                        <img
                                                            src={getChannelPicture(this.state.userDetails, account_icon, "profile_pic")}
                                                            alt="Accounts icon"/></div>
                                                    <div className="icon-edit"
                                                         onClick={() => {
                                                             //"broadcaster_channel_image"//broadcaster_profile_pic,user_profile_pic
                                                             this.setState({
                                                                 uploadType: "broadcaster_profile_pic"
                                                             }, () => {
                                                                 document.getElementById("user-profile-image-modal-file").click()
                                                             });
                                                         }}/>
                                                </div>
                                            </div>
                                            :
                                            <div className="followers-img-wrapper">
                                                <div className="followers-img">
                                                    <img
                                                        src={getUserProfilePicture(this.state.userDetails, account_icon)}
                                                        alt="Accounts icon"/></div>
                                                <div className="icon-edit"
                                                     onClick={() => {
                                                         //"broadcaster_channel_image"//broadcaster_profile_pic,user_profile_pic
                                                         this.setState({
                                                             uploadType: "user_profile_pic"
                                                         }, () => {
                                                             document.getElementById("user-profile-image-modal-file").click()
                                                         });
                                                     }}/>
                                            </div>
                                    }


                                    {
                                        this.state.userDetails &&
                                        <h5>{this.state.userDetails.username}</h5>
                                    }

                                    {
                                        (this.state.isChannelDescriptionEdited || this.state.isChannelTagsEdited)
                                            ?
                                            <div className="profile-container" style={{padding: '0px'}}>
                                                <div className="profile-wrapper" style={{padding: '0px'}}>
                                                    <form>
                                                        {
                                                            this.state.isChannelDescriptionEdited
                                                                ?
                                                                <Field
                                                                    label="Channel description"
                                                                    name="channel_description"
                                                                    type="textarea"
                                                                    maxLength="500"
                                                                    count={this.state.count}
                                                                    validate={[required]}
                                                                    component={renderTextAreaField}
                                                                    onChange={this.textAreaChange}
                                                                />
                                                                :
                                                                <div>
                                                                    <p>Channel tags</p>
                                                                    <div className="vertical-container-100">
                                                                        <PlaceHolderComponent type={'text'} rows={5}
                                                                                              ready={this.state.predefinedTagsList != null}>

                                                                            <ul className="tags">
                                                                                {
                                                                                    this.state.predefinedTagsList != null && _.map(this.state.predefinedTagsList, (tag) => {
                                                                                        return <li key={tag.id}
                                                                                                   id={`predefined-${tag.id}`}
                                                                                                   onClick={this.togglePrefinedTags}
                                                                                                   data-id={tag.id}
                                                                                                   data-name={tag.name}>{tag.name}</li>;
                                                                                    })
                                                                                }
                                                                            </ul>

                                                                        </PlaceHolderComponent>
                                                                    </div>
                                                                    <div className="form-group add-tags">
                                                                        <input className="form-control" maxLength="20"
                                                                               type="text" placeholder="Create new tag"
                                                                               id="create-new-tag"/>
                                                                        <button className="btn btn-outline-primary"
                                                                                style={{
                                                                                    textIndent: '-20px',
                                                                                    height: '30px',
                                                                                    border: '1px solid'
                                                                                }} onClick={this.addTag}>Add tag
                                                                        </button>
                                                                    </div>
                                                                    <p>Your tags</p>
                                                                    <div style={{margin: '10px 0 10px 0'}}> You can
                                                                        select a
                                                                        minimum of one tag and maximum
                                                                        of five
                                                                    </div>
                                                                    <div className="vertical-container-100">
                                                                        <ul className="tags">
                                                                            {
                                                                                _.map(this.state.tags, (tag, index) => {
                                                                                    return <li key={index}
                                                                                    >{tag.name}
                                                                                        <span className="close"
                                                                                              data-id={tag.id}
                                                                                              data-ispredefined={tag.ispredefined}
                                                                                              data-name={tag.name}
                                                                                              onClick={this.removeTag}>×</span>
                                                                                    </li>
                                                                                })
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                        }
                                                    </form>

                                                </div>
                                            </div>
                                            :
                                            <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                                <Field
                                                    label="Email"
                                                    name="email"
                                                    type="email"
                                                    username={null}
                                                    password_class="btn btn-edit"
                                                    disabled={true}
                                                    height={"47"}
                                                    buttonClick={this.editChangeEmail}
                                                    component={renderField}
                                                />
                                                {this.state.isChangeEmailEnabled && <Field
                                                    label="New Email"
                                                    name="new_email"
                                                    type="email"
                                                    username={null}
                                                    email={true}
                                                    height={"47"}
                                                    validate={[this.required]}
                                                    component={renderField}
                                                />}
                                                {!this.state.isChangePasswordEnabled && !this.state.isChangeEmailEnabled &&
                                                <Field
                                                    label="Password"
                                                    name="password"
                                                    type={this.state.type}
                                                    username={null}
                                                    password_class="btn btn-edit"
                                                    buttonClick={this.editChangePassword}
                                                    validate={[this.required]}
                                                    disabled={true}
                                                    height={"47"}
                                                    component={renderField}
                                                />
                                                }
                                                {this.state.isChangePasswordEnabled &&
                                                <Field
                                                    label="Current password"
                                                    name="current_password"
                                                    type={this.state.current_pwd_type}
                                                    username={null}
                                                    is_password={true}
                                                    height={"47"}
                                                    password_class={this.state.current_pwd_class_name}
                                                    buttonClick={this.showHidePassword}
                                                    validate={[this.required]}
                                                    component={renderField}
                                                />}
                                                {this.state.isChangePasswordEnabled &&
                                                <Field
                                                    label="New password"
                                                    name="new_password"
                                                    type={this.state.new_password_pwd_type}
                                                    username={null}
                                                    is_password={true}
                                                    height={"47"}
                                                    password_class={this.state.new_password_class_name}
                                                    buttonClick={this.showHidePassword}
                                                    validate={[this.required, isValidPassword]}
                                                    component={renderField}
                                                />
                                                }
                                                {this.state.isChangePasswordEnabled &&
                                                <Field
                                                    label="Confirm new password"
                                                    name="confirm_password"
                                                    type={this.state.confirm_password_pwd_type}
                                                    username={null}
                                                    is_password={true}
                                                    height={"47"}
                                                    password_class={this.state.confirm_password_class_name}
                                                    buttonClick={this.showHidePassword}
                                                    validate={[this.required, this.checkPasswordsMatch]}
                                                    component={renderField}

                                                />
                                                }
                                                {this.state.isChangePasswordEnabled &&
                                                <h1 className="small">{strings.valid.password}</h1>
                                                }

                                                {
                                                    this.state.isBroadcaster &&
                                                    <div>
                                                        <div className="form-group">
                                                            <label>Channel description</label>
                                                            <div className="input-group">
                                                                    <textarea className="form-control"
                                                                              placeholder="Channel description"
                                                                              style={{backgroundColor: '#ffffff'}}
                                                                              disabled
                                                                              defaultValue={this.state.userDetails.broadcaster[0].channel_description}>
                                                                    </textarea>
                                                                <div className="input-group-append">
                                                                    <button className="btn btn-edit" type="button"
                                                                            onClick={this.editChannelDescription}>Edit
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-group">
                                                            <label>Your tags</label>
                                                            <div className="input-group">
                                                                <h1 className="small form-control"
                                                                    placeholder="Your tags"
                                                                    type="text"> {this.getListOfTags()} </h1>
                                                                <div className="input-group-append">
                                                                    <button className="btn btn-edit" type="button"
                                                                            onClick={this.editChannelTag}>Edit
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                }

                                                <button id="saveBtn" type="submit" className="btn btn-outline-primary">
                                                </button>
                                            </form>
                                    }

                                </div>
                            }

                            <div className="modal-footer">
                                {
                                    (this.state.isChangePasswordEnabled || this.state.isChangeEmailEnabled) &&

                                    <button type="submit" className="btn btn-outline-primary" onClick={() => {
                                        document.getElementById("saveBtn").click()
                                    }}>
                                        {
                                            (this.props.account_management.isFetching || this.props.broadcasterProfile.isFetching)
                                                ?
                                                <img src={loading_white} alt={"Loading"} width={26} height={26}/>
                                                :
                                                `${this.getSaveButtonName()}`
                                        }
                                    </button>
                                }
                                {
                                    this.state.isChannelDescriptionEdited &&
                                    <button type="submit" className="btn btn-outline-primary"
                                            onClick={this.onClickSaveChannelDescription}>
                                        {
                                            this.props.broadcasterProfile.isFetching
                                                ?
                                                <img src={loading_white} alt={"Loading"} width={26} height={26}/>
                                                :
                                                `${this.getSaveButtonName()}`
                                        }
                                    </button>
                                }
                                {
                                    this.state.isChannelTagsEdited &&
                                    <button type="submit" className="btn btn-outline-primary"
                                            onClick={this.onClickSaveChannelTags}>
                                        {
                                            this.props.broadcasterProfile.isFetching
                                                ?
                                                <img src={loading_white} alt={"Loading"} width={26} height={26}/>
                                                :
                                                `${this.getSaveButtonName()}`
                                        }
                                    </button>
                                }
                                <a className="btn btn-link" data-dismiss="modal"
                                   onClick={this.hideUserProfile}>Cancel</a>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {

    if (state.account_management.userDetails !== null &&
        state.account_management.userDetails !== undefined &&
        state.account_management.userDetails.hasOwnProperty("broadcaster") &&
        state.account_management.userDetails.broadcaster !== null &&
        state.account_management.userDetails.broadcaster.length > 0) {

        return {
            account_management: state.account_management,
            broadcasterProfile: state.broadcasterProfile,
            device: state.device.payload,
            predefinedTags: state.predefinedTags,
            initialValues: {
                ...state.account_management.userDetails,
                channel_description: state.account_management.userDetails.broadcaster[0].channel_description,
                password: "**********"
            }
        };
    }
    else {
        return {
            account_management: state.account_management,
            broadcasterProfile: state.broadcasterProfile,
            device: state.device.payload,
            predefinedTags: state.predefinedTags,
            initialValues: {
                ...state.account_management.userDetails,
                password: "**********"
            }
        };
    }

}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
UserProfile = reduxForm({
    form: 'userProfileForm', // a unique identifier for this form
    enableReinitialize: true,
})(UserProfile);

// You have to connect() to any reducers that you wish to connect to yourself
UserProfile = connect(
    mapStateToProps, // pull initial values from account reducer
    actions // bind account loading action creator
)(UserProfile);

export default withRouter(UserProfile)